// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#tblMain[data-v-469dce95] {\r\n  width: 1000px;\n}\n.btn[data-v-469dce95] {\r\n  color: white !important;\r\n  margin: 5px;\r\n  /*width: 40px;*/\n}\n.row[data-v-469dce95] {\r\n  padding: 0px;\n}\n.thisDiv[data-v-469dce95] {\r\n  padding: 10px;\r\n  background-color: #fafafa;\n}\n.thisLabel[data-v-469dce95] {\r\n  width: 300px;\n}\n.thisControl[data-v-469dce95] {\r\n  width: 400px;\n}\r\n", ""]);
// Exports
module.exports = exports;
